/* eslint-disable  */
// import { getCoreBlocks } from './core.js';

const gap = '<sep gap="36"/>';
const blockSeparator = '<sep gap="36"/>'; // At default scale, about 28px


const cdg3_event_blocks = function () {
  return `
  <category
    name="Event"
    id="cdg3_event"
    colour="#FFBF00"
    secondaryColour="#E6AC00">

      <block type="cdg3_event_when_tracking_ball_lands">
      </block>

      <block type="cdg3_event_when_toxibots_get_near">
      </block>

      <block type="cdg3_event_when_no_toxibots_near">
      </block>

      <block type="cdg3_event_when_captured_toxibot_is_under_attack">
      </block>

      <block type="cdg3_event_when_toxibot_is_stunned">
      </block>

      <block type="cdg3_event_when_player_clubhouse">
        <field name="MOVEMENT">leaves</field>
      </block>

  </category>
  `
}
const cdg3_sensing_blocks = function () {
  return `
  <category
    name="Sensing"
    id="cdg3_sensing"
    colour="#3ECBF0"
    secondaryColour="#2cb5da">
      <block type="cdg3_sensing_captured_toxibots">
      </block>
      <block type="cdg3_sensing_toxibots_nearby">
      </block>
      <block type="cdg3_sensing_stunned_toxibots">
      </block>
      <block type="cdg3_sensing_attacking_toxibots">
      </block>
  </category>
  `
}
const cdg3_action_blocks = function () {
  return `
  <category
    name="Action"
    id="cdg3_action"
    colour="#0fBD8C"
    secondaryColour="#0DA57A">
    
      <block type="cdg3_action_move_to">
        <field name="UNIT">Tracking Ball</field>
      </block>

      <block type="cdg3_action_follow">
        <field name="UNIT">Player</field>
      </block>

      <block type="cdg3_action_start_capturing">
      </block>

      <block type="cdg3_action_run_away">
      </block>
  </category>
  `
}
const cdg3_control_blocks = function () {
  return `
  <category name="%{BKY_CATEGORY_CONTROL}" id="control" colour="#FFAB19" secondaryColour="#CF8B17">
    <block type="control_if"/>
    <block type="control_if_else"/>
    <block id="wait_until" type="control_wait_until"/>
  </category>
  `
}
const cdg3_operators_blocks = function () {

  return `
<category name="%{BKY_CATEGORY_OPERATORS}" id="operators" colour="#40BF4A" secondaryColour="#389438">
  <block type="operator_gt">
  <value name="OPERAND1">
      <shadow type="text">
          <field name="TEXT"/>
      </shadow>
  </value>
  <value name="OPERAND2">
      <shadow type="text">
          <field name="TEXT">5</field>
      </shadow>
  </value>
</block>
<block type="operator_lt">
  <value name="OPERAND1">
      <shadow type="text">
          <field name="TEXT"/>
      </shadow>
  </value>
  <value name="OPERAND2">
      <shadow type="text">
          <field name="TEXT">5</field>
      </shadow>
  </value>
</block>
<block type="operator_equals">
  <value name="OPERAND1">
      <shadow type="text">
          <field name="TEXT"/>
      </shadow>
  </value>
  <value name="OPERAND2">
      <shadow type="text">
          <field name="TEXT">5</field>
      </shadow>
  </value>
</block>
${blockSeparator}
<block type="operator_and"/>
<block type="operator_or"/>
<block type="operator_not"/>
${blockSeparator}
</category>`

}
const makeCDG3ToolboxXML = () => {
  const xmlOpen = '<xml style="display: none">';
  const xmlClose = "</xml>";
  // const coreCategories = getCoreBlocks();
  return [
    xmlOpen,
    gap,
    cdg3_event_blocks(),
    gap,
    cdg3_action_blocks(),
    gap,
    cdg3_sensing_blocks(),
    gap,
    cdg3_control_blocks(),
    gap,
    cdg3_operators_blocks(),
    gap,
    xmlClose
  ].join("\n");
}

export { makeCDG3ToolboxXML };